module.exports = __webpack_public_path__ + "img/mis_wx.6809d50a.png";